export default "__VITE_ASSET__DcSAPx75__"